
<div class="container-fluid">

  <!--START: Header design-->
  <div class="row headerRow" [ngStyle]="styleClass(__sColor)" id="dashboardHeader" *ngIf="!hideDashboardMenu">
    <div class="col-lg-12 col-md-12 col-xs-12 padding0px">
      <div class="div-banner-left">
        <div class="imgRiskCubedLogo">
          <span *ngIf="__sEnvironment != 'PROD'" class="environment-title">{{__sEnvironment}}</span>
          <a id="logo-riskcubed" class="clickable" (click)="loadMainMenu(false)">
            <img src="assets/Images/DashBoardManagement/riskcubed_logo.svg" alt="RiskCubedLogo" />
          </a>
        </div>
        <div *ngIf="__bIsAuthorised" class="div-menu-text" [ngClass]="{'div-menu-text-active': __bMenu }" [ngStyle]="menuStyleClass(__sColor)">
          <span id="menuIconSpan-menu" class="menu-text clickable" (click)="toggleMenu()">Menu</span>
          <span id="menuIconSpan-down" class="icon dx-icon-chevrondown clickable" (click)="toggleMenu()"></span>
        </div>
        <div *ngIf="__bIsAuthorised" class="breadcrumb">
          <span title="{{__sBreadCrumbs}}">{{__sBreadCrumbs}}</span>
        </div>
      </div>

      <div *ngIf="__bIsAuthorised" class="div-banner-right">
        <div class="clickable" (click)="invokeAddEntityInstanceScreen()">
          <a id="addInstance" title="Add new" [routerLink]="['/AddCounterparty']">
            <div class="col-lg-12 col-md-12 col-xs-12 padding0px">
              <span class="icon top-addnew"></span>
            </div>
            <div class="col-lg-12 col-md-12 col-xs-12 padding0px">
              <span>Add New</span>
            </div>
          </a>
        </div>

        <div class="clickable" (click)="invokeDataSearchScreen()">
          <a id="dataSearch" title="Data Search" [routerLink]="['/DataSearch']">
            <div class="col-lg-12 col-md-12 col-xs-12 padding0px">
              <span class="icon top-datasearch"></span>
            </div>
            <div class="col-lg-12 col-md-12 col-xs-12 padding0px">
              <span> Data Search</span>
            </div>
          </a>
        </div>

        <div class="clickable" data-toggle="collapse" (click)="toggleUserPreferences()"
             [ngClass]="{'div-account-text-active': __bUserPreferencesMenu }" [ngStyle]="accountStyleClass(__sColor)">
          <a title="User settings">
            <div class="col-lg-12 col-md-12 col-xs-12 padding0px">
              <span id="accountIcon" class="icon top-account"></span>
            </div>
            <div class="col-lg-12 col-md-12 col-xs-12 padding0px">
              <span id="accountSpan">Account</span>
            </div>
          </a>
          <div style="width: 5%;">
            <!--<div *ngIf="__bUserPreferencesMenu" class="bubbleStyle"></div>-->
            <div *ngIf="__bUserPreferencesMenu" class="paneDisplaySettings">
              <div class="col-lg-12 col-md-12 col-xs-12 padding0px">
                <div class="col-lg-6 col-md-6 col-xs-6 padding0px"><span>User:</span></div>
                <div class="col-lg-6 col-md-6 col-xs-6 padding0px text-ellipsis">
                  <span title="{{__sUserName}}">{{__sUserName | lowercase}}</span>
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-xs-12 padding0px">
                <div class="col-lg-6 col-md-6 col-xs-6 padding0px"><span>Date today:</span></div>
                <div class="col-lg-6 col-md-6 col-xs-6 padding0px"><span>{{__dLastLoggedInDateTime | date :  __sPortalDateFormat}}</span></div>
              </div>
              <div class="col-lg-12 col-md-12 col-xs-12 padding0px">
                <div class="col-lg-6 col-md-6 col-xs-6 padding0px"><span>Environment:</span></div>
                <div class="col-lg-6 col-md-6 col-xs-6 padding0px"><span>{{__sEnvironment}}</span></div>
              </div>
              <div class="col-lg-12 col-md-12 col-xs-12 padding0px">
                <div class="col-lg-6 col-md-6 col-xs-6 padding0px"><span>Version:</span></div>
                <div class="col-lg-6 col-md-6 col-xs-6 padding0px"><span>{{releaseVersion}}</span></div>
              </div>
              <div class="col-lg-12 col-md-12 col-xs-12 padding0px">
                <div class="col-lg-6 col-md-6 col-xs-6 padding0px"><span>Data last updated:</span></div>
                <div class="col-lg-6 col-md-6 col-xs-6 padding0px"><span>{{__dValuationDateTime | date :  __sPortalDateFormat}}</span></div>
              </div>
              <div class="col-lg-12 col-md-12 col-xs-12 padding0px" style="text-align:center; padding: 1.4rem 0 0 0; ">
                <div class="col-lg-12 col-md-12 col-xs-12 padding0px" *ngIf="__bPasswordChangePopUpButtonVisible" style="margin-bottom: 0.7rem; ">
                  <button id="btnChangePassword" class="btn btn-secondary" (click)="OpenChangePasswordPopUp()" style="width: 11.6rem; ">
                    <span>Change password</span>
                  </button>
                </div>
                <div class="col-lg-12 col-md-12 col-xs-12 padding0px">
                  <button id="btnLogout" class="btn btn-secondary" (click)="windowClose()" style="width: 11.6rem; ">
                    <span>Logout</span>
                  </button>
                </div>
              </div>




            </div>
          </div>

        </div>

        <div style="width: 0.2rem; ">
        </div>

      </div>


    </div>
  </div>
  <!--END: Header design-->

  <div class="row" style="margin: auto;">

    <div id="div-menu" class="col-4 padding0px div-menu" [ngStyle]="{'display':__bMenu ? 'block': 'none'}">
      <!--START: Settings & Portal menu -->
      <div id="portalMenu" class="col padding0px cl-treeview">
        <!--START: Menu items-->
        <div class="menuWrapper">


          <dx-tree-view #tvMenuPane id="tvMenuPane" class="cl-tree-view"
                        [dataSource]="__lHierarchicalMenuData"
                        itemsExpr="dashBoardPortalMenuParentChildViews"
                        keyExpr="lDashBoardPortalMenuId"
                        displayExpr="DashBoardPortalMenu"
                        [searchEnabled]="true"
                        searchMode="contains"
                        [searchEditorOptions]="{ placeholder: 'Navigate straight to...' }"
                        (onItemClick)="ItemClicked($event)"
                        (onContentReady)="onContentReady($event)"
                        style="height:100%"
                        itemTemplate="itemTemplate">

            <div *dxTemplate="let data of 'itemTemplate'" class="col-lg-12 col-md-12 col-xs-12 padding0px"
                 [ngStyle]="{'line-height': data.lDashBoardPortalMenuParentId == 0 ? data.IsCustomMenu == 1 ? '1.9rem' : '2.9rem' : '2rem'}">

              <div [ngStyle]="{'margin' : data.lDashBoardPortalMenuParentId != 0 ? '' : '0 -0.7rem'}" class="row padding0px">


                <!--Show only top parent menus & sub-menus (these are div and use routeLink method to navigate, if any)-->

                <div class="row padding0px"
                     *ngIf="

                   ((data.lDashBoardPortalMenuParentId == 0 ) ||

                   (data.QueryString == null )) &&
                   (data.IsCustomMenu != 1) &&
                   (data.DashBoardPortalMenu != 'Policy Management') &&

                   (data.DashBoardPortalMenu != 'Document Template Management') &&

                   (data.DashBoardPortalMenu != 'Customer Underwriting')"
                     style="width: 100%;" (click)="routeLink(data, $event)">

                  <img class="col padding0px img-menu-icon" *ngIf="data.lDashBoardPortalMenuParentId == 0 && data.Image != 'PolicyManagement' && data.Image != 'CustomerLimitAssessment' && data.Image != 'RegulatoryRisk'"
                       src="assets/Images/DashBoardManagement/MenuIcons/CubeLogic-{{data.Image}}.svg">

                  <img class="col padding0px img-menu-icon" *ngIf="data.lDashBoardPortalMenuParentId == 0 && data.Image != 'PolicyManagement' && data.Image != 'CustomerLimitAssessment' && data.Image == 'RegulatoryRisk'"
                       src="assets/Images/DashBoardManagement/MenuIcons/CubeLogic-{{data.Image}}.svg" style="margin-left: 10px;height:25px;width:25px;">

                  <button *ngIf="data.lDashBoardPortalMenuParentId != 0"
                          type="button"
                          class="btn btn-default btn-menu-pane"
                          [ngClass]="{'dx-item-selected': data.DashBoardPortalMenu === __sSelectedItem }">
                    {{data.Image}}

                  </button>
                  <div class="col-lg-10 col-md-10 col-xs-10 padding0px" [ngStyle]="{'padding': data.lDashBoardPortalMenuParentId == 0 ? '0rem 0rem 0rem 0.3rem': '0.1rem 0rem 0rem 0.7rem'}">

                    <span Class="clickable" id="menuIconSpan{{data.lDashBoardPortalMenuId}}"
                          [ngClass]="{'dx-item-selected': data.DashBoardPortalMenu === __sSelectedItem }">{{data.DashBoardPortalMenu}}</span>

                  </div>

                </div>



                <!--Silver light redirections (these are div and use routeLink method in dashboardapp.component.ts to navigate)-->
                <div class="row padding0px"
                     *ngIf="

                  ((data.DashBoardPortalMenu == 'Treasury Management') ||

                   (data.DashBoardPortalMenu == 'Reporting Dashboard') ||

                   (data.DashBoardPortalMenu == 'Exposure Override') ||



                   (data.DashBoardPortalMenu == 'Cash Pool Management') ||



                   (data.DashBoardPortalMenu == 'Product Management') ||

                   (data.DashBoardPortalMenu == 'Position Management') ||


                   (data.ParentName == 'Regulatory') ||

                   (data.ParentName == 'User Setup' && (data.DashBoardPortalMenu != 'User Management' && data.DashBoardPortalMenu != 'User Role Management'
                                                      && data.DashBoardPortalMenu == 'Entity Association' && data.DashBoardPortalMenu ==  'Identifier Management')) ||

                   (data.DashBoardPortalMenu.trim() == 'Report Explorer') ||

                   (data.ParentName == 'Financial & Scoring Model' && (data.DashBoardPortalMenu != 'Financial Spreads Admin' && data.DashBoardPortalMenu != 'Scorecard'
                                                      && data.DashBoardPortalMenu != 'Scoring Model')) ||


                   (data.lDashBoardPortalMenuId == 14) ||

                   (data.lDashBoardPortalMenuId == 16) ||

                   (data.lDashBoardPortalMenuId == 51)) &&


                   (data.lDashBoardPortalMenuParentId != 0) &&

                   (data.QueryString != null ) &&

                   (data.DashBoardPortalMenu != 'Policy Management') &&

                   (data.DashBoardPortalMenu != 'Document Template Management') &&

                   (data.DashBoardPortalMenu != 'Customer Underwriting') && (data.IsStaticEntity != 1)"
                     style="width: 100%;" (click)="routeLink(data, $event)">


                  <img class="col padding0px img-menu-icon" *ngIf="data.lDashBoardPortalMenuParentId == 0 && data.Image != 'PolicyManagement' && data.Image != 'CustomerLimitAssessment'"
                       src="assets/Images/DashBoardManagement/MenuIcons/CubeLogic-{{data.Image}}.svg" />


                  <button *ngIf="data.lDashBoardPortalMenuParentId != 0"
                          type="button"
                          class="btn btn-default btn-menu-pane"
                          [ngClass]="{'dx-item-selected': data.DashBoardPortalMenu === __sSelectedItem }">
                    {{data.Image}}

                  </button>
                  <div class="col-lg-10 col-md-10 col-xs-10 padding0px" [ngStyle]="{'padding': data.lDashBoardPortalMenuParentId == 0 ? '0rem 0rem 0rem 0.3rem': '0.1rem 0rem 0rem 0.7rem'}">

                    <span Class="clickable" id="menuIconSpan{{data.lDashBoardPortalMenuId}}"
                          [ngClass]="{'dx-item-selected': data.DashBoardPortalMenu === __sSelectedItem }">{{data.DashBoardPortalMenu}}</span>

                  </div>

                </div>



                <!--MenuIds which do not need to be attached to url (these are anchor tags and use [routerLink] to navigate)-->

                <a data-dismiss="modal" class="row padding0px"
                   role="button"
                   *ngIf="

                (data.lDashBoardPortalMenuId == 76 ||

                 data.lDashBoardPortalMenuId == 57 ||

                 data.lDashBoardPortalMenuId == 77 ||

                 data.lDashBoardPortalMenuId == 66  ||

                 (data.DashBoardPortalMenu == 'Position Limit Dashboard')) &&


                (data.lDashBoardPortalMenuParentId != 0) &&

                (data.QueryString != null ) &&

                (data.DashBoardPortalMenu != 'Policy Management') &&

                (data.DashBoardPortalMenu != 'Document Template Management') &&

                (data.DashBoardPortalMenu != 'Customer Underwriting')"
                   style="width: 100%;"
                   [routerLink]="[data.QueryString != null ? data.QueryString.trim() : '']"
                   (click)="onClickMainMenuItem(data.DashBoardPortalMenu)">

                  <img class="col padding0px img-menu-icon" *ngIf="data.lDashBoardPortalMenuParentId == 0 && data.Image != 'PolicyManagement' && data.Image != 'CustomerLimitAssessment'"
                       src="assets/Images/DashBoardManagement/MenuIcons/CubeLogic-{{data.Image}}.svg">



                  <button *ngIf="data.lDashBoardPortalMenuParentId != 0"
                          type="button"
                          class="btn btn-default btn-menu-pane"
                          [ngClass]="{'dx-item-selected': data.DashBoardPortalMenu === __sSelectedItem }">
                    {{data.Image}}

                  </button>
                  <div class="col-lg-10 col-md-10 col-xs-10 padding0px" [ngStyle]="{'padding': data.lDashBoardPortalMenuParentId == 0 ? '0rem 0rem 0rem 0.3rem': '0.1rem 0rem 0rem 0.7rem'}">

                    <span Class="clickable" id="menuIconSpan{{data.lDashBoardPortalMenuId}}"
                          [ngClass]="{'dx-item-selected': data.DashBoardPortalMenu === __sSelectedItem }">{{data.DashBoardPortalMenu}}</span>

                  </div>

                </a>



                <!--MenuIds which need to be attached to url (these are anchor tags and use [routerLink] to navigate)-->

                <a data-dismiss="modal" class="row padding0px" style="width: 100%;"
                   *ngIf="(
                      (data.lDashBoardPortalMenuId != 76) &&

                      (data.lDashBoardPortalMenuId != 77) &&

                      (data.lDashBoardPortalMenuId != 14) &&

                      (data.lDashBoardPortalMenuId != 16) &&

                      (data.lDashBoardPortalMenuId != 51) &&

                      (data.lDashBoardPortalMenuId != 66 ) &&

                      (data.DashBoardPortalMenu != 'Reporting Dashboard') &&

                      (data.DashBoardPortalMenu != 'Treasury Management') &&

                      (data.DashBoardPortalMenu != 'Exposure Override') &&

                      (data.DashBoardPortalMenu != 'Position Limit') &&

                      (data.DashBoardPortalMenu != 'Cash Pool Management') &&

                      (data.DashBoardPortalMenu != 'Bank Management') &&

                      (data.DashBoardPortalMenu != 'Product Management') &&

                      (data.DashBoardPortalMenu != 'Position Management') &&

                      (data.IsStaticEntity != 1) &&

                      (data.IsCustomMenu != 1) &&

                      (data.ParentName != 'Regulatory') &&

                      (data.ParentName != 'Treasury') &&

                      (data.ParentName != 'User Setup' || (data.DashBoardPortalMenu == 'User Management' || data.DashBoardPortalMenu ==  'User Role Management'
                                                          || data.DashBoardPortalMenu == 'Entity Association' || data.DashBoardPortalMenu ==  'Identifier Management')) &&

                      (data.DashBoardPortalMenu.trim() != 'Report Explorer') &&

                      (data.ParentName != 'Financial & Scoring Model' || (data.DashBoardPortalMenu == 'Financial Spreads Admin' ||    data.DashBoardPortalMenu == 'Scorecard' ||
                                        data.DashBoardPortalMenu == 'Scoring Model')


                 ) &&

                      (data.ParentName != 'Regulatory Risk') ) &&
                      (data.lDashBoardPortalMenuParentId != 0)  &&

                      (data.QueryString != null )  &&

                      (data.DashBoardPortalMenu != 'Policy Management') &&
                   

                   (data.DashBoardPortalMenu != 'Document Template Management') &&

                  (data.DashBoardPortalMenu != 'Customer Underwriting')"
                   [routerLink]="[data.QueryString  != null ? data.QueryString.trim() + '/' +  data.lDashBoardPortalMenuId : '']"
                   (click)="onClickMainMenuItem(data.DashBoardPortalMenu)">

                  <img class="col padding0px img-menu-icon" *ngIf="data.lDashBoardPortalMenuParentId == 0 && data.Image != 'PolicyManagement' && data.Image != 'CustomerLimitAssessment'"
                       src="assets/Images/DashBoardManagement/MenuIcons/CubeLogic-{{data.Image}}.svg">


                  <button *ngIf="data.lDashBoardPortalMenuParentId != 0"
                          type="button"
                          class="btn btn-default btn-menu-pane"
                          [ngClass]="{'dx-item-selected': data.DashBoardPortalMenu === __sSelectedItem }">
                    {{data.Image}}

                  </button>
                  <div class="col-lg-10 col-md-10 col-xs-10 padding0px" [ngStyle]="{'padding': data.lDashBoardPortalMenuParentId == 0 ? '0rem 0rem 0rem 0.3rem': '0.1rem 0rem 0rem 0.7rem'}">

                    <span Class="clickable" id="menuIconSpan{{data.lDashBoardPortalMenuId}}"
                          [ngClass]="{'dx-item-selected': data.DashBoardPortalMenu === __sSelectedItem }">{{data.DashBoardPortalMenu}}</span>

                  </div>

                </a>


                <!--static admin MenuIds which need to be attached to url (these are anchor tags and use [routerLink] to navigate)-->

                <a data-dismiss="modal" class="row padding0px" style="width: 100%;"
                   *ngIf="data.IsStaticEntity == 1"
                   [routerLink]="[data.QueryString  != null ? 'StaticAdmin/' + data.QueryString.trim() : '']"
                   (click)="onClickMainMenuItem(data.DashBoardPortalMenu)">

                  <img class="col padding0px img-menu-icon" *ngIf="data.lDashBoardPortalMenuParentId == 0 && data.Image != 'PolicyManagement' && data.Image != 'CustomerLimitAssessment'"
                       src="assets/Images/DashBoardManagement/MenuIcons/CubeLogic-{{data.Image}}.svg">


                  <button *ngIf="data.lDashBoardPortalMenuParentId != 0"
                          type="button"
                          class="btn btn-default btn-menu-pane"
                          [ngClass]="{'dx-item-selected': data.DashBoardPortalMenu === __sSelectedItem }">
                    {{data.Image}}

                  </button>
                  <div class="col-lg-10 col-md-10 col-xs-10 padding0px" [ngStyle]="{'padding': data.lDashBoardPortalMenuParentId == 0 ? '0rem 0rem 0rem 0.3rem': '0.1rem 0rem 0rem 0.7rem'}">

                    <span Class="clickable" id="menuIconSpan{{data.lDashBoardPortalMenuId}}"
                          [ngClass]="{'dx-item-selected': data.DashBoardPortalMenu === __sSelectedItem }">{{data.DashBoardPortalMenu}}</span>

                  </div>

                </a>

                <!--Document Template Management-->

                <a data-dismiss="modal" class="row padding0px" style="width: 100%;"
                   *ngIf="(data.QueryString != null) && (data.QueryString == 'DocumentTemplateMangement')"
                   [routerLink]="[data.QueryString]"
                   (click)="onClickMainMenuItem(data.DashBoardPortalMenu)">

                  <img class="col padding0px" *ngIf="data.Image == 'DocumentTemplateManagement'"
                       src="assets/Images/DashBoardManagement/MenuIcons/icon_{{data.Image}}_Blue.png"
                       style="margin: 8px 8px 0 10px; display: inline-block; float: left; width: 25px; height: 25px">


                  <div class="col-lg-10 col-md-10 col-xs-10 padding0px">

                    <span Class="clickable" id="menuIconSpan{{data.lDashBoardPortalMenuId}}">{{data.DashBoardPortalMenu}}</span>

                  </div>


                </a>
                <!--Policy Management-->

                <a data-dismiss="modal" class="row padding0px" style="width: 100%;"
                   *ngIf="(data.QueryString != null) && (data.QueryString == 'PolicyManagement')"
                   [routerLink]="[data.QueryString]"
                   (click)="onClickMainMenuItem(data.DashBoardPortalMenu)">

                  <img class="col padding0px" *ngIf="data.Image == 'PolicyManagement'"
                       src="assets/Images/DashBoardManagement/MenuIcons/icon_{{data.Image}}_Blue.png"
                       style="margin: 8px 8px 0 10px; display: inline-block; float: left; width: 25px; height: 25px">


                  <div class="col-lg-10 col-md-10 col-xs-10 padding0px">

                    <span Class="clickable" id="menuIconSpan{{data.lDashBoardPortalMenuId}}">{{data.DashBoardPortalMenu}}</span>

                  </div>


                </a>

                <!--Policy Customer Underwriting-->

                <a data-dismiss="modal" class="row padding0px" style="width: 100%;"
                   *ngIf="(data.QueryString != null ) && (data.QueryString == 'PolicyCustomerLimitAssesment')"
                   [routerLink]="[data.QueryString]"
                   (click)="onClickMainMenuItem(data.DashBoardPortalMenu)">

                  <img class="col padding0px" *ngIf="data.Image == 'CustomerUnderwriting'"
                       src="assets/Images/DashBoardManagement/MenuIcons/icon_{{data.Image}}_Blue.png"
                       style="margin: 8px 8px 0 10px; display: inline-block; float: left; width: 25px; height: 25px">
                  <div class="col-lg-10 col-md-10 col-xs-10 padding0px">
                    <span Class="clickable" id="menuIconSpan{{data.lDashBoardPortalMenuId}}">{{data.DashBoardPortalMenu}}</span>
                  </div>
                </a>

                <!--Custom View-->
                <a data-dismiss="modal" class="row padding0px" style="width: 100%;"
                   *ngIf="data.IsCustomMenu == 1"
                   [routerLink]="[data.QueryString  != null ? data.QueryString.trim() : '']"
                   (click)="onClickMainMenuItem(data.DashBoardPortalMenu)">



                  <button type="button"
                          class="btn btn-default btn-menu-pane"
                          [ngClass]="{'dx-item-selected': data.DashBoardPortalMenu === __sSelectedItem }">
                    {{data.Image}}

                  </button>
                  <div class="col-lg-10 col-md-10 col-xs-10 padding0px" [ngStyle]="{'padding': data.lDashBoardPortalMenuParentId == 0 ? '0rem 0rem 0rem 0.3rem': '0.1rem 0rem 0rem 0.7rem'}">

                    <span Class="clickable" id="menuIconSpan{{data.lDashBoardPortalMenuId}}"
                          [ngClass]="{'dx-item-selected': data.DashBoardPortalMenu === __sSelectedItem }">{{data.DashBoardPortalMenu}}</span>

                  </div>

                </a>


              </div>

            </div>
          </dx-tree-view>



        </div>

        <!--END: Menu items-->

        <dx-load-panel id="pnlLoad"
                       shadingColor="rgba(0,0,0,0.4)"
                       [position]="{ of: '#portalMenu' }"
                       [(visible)]="IsLoadingVisible"
                       [showIndicator]="true"
                       [showPane]="true"
                       [shading]="true"
                       [hideOnOutsideClick]="false"
                       [height]="75"
                       [width]="150">
        </dx-load-panel>


      </div>
      <!--END: Settings & Portal menu -->
    </div>

    <!--START: Content division -->
    <div class="col padding0px content" style="margin:0px;" id="ScrolltoTop">
      <app-notification [hidden]="!__bPasswordChangePopUpButtonVisible" (onInitialized)="InitializeNotification($event)"
                        [__sNotificationMessage]="__sPasswordExpiryWarningMessage"
                        [__bIsPasswordExpiryNotification]="__bPasswordChangePopUpButtonVisible"
                        (childEvent)="OpenChangePasswordPopUp()"></app-notification>
      <router-outlet></router-outlet>
    </div>
    <!--START: Content division -->
  </div>


</div>



<dx-popup id="PopUpChangePassword"
          [wrapperAttr]="{ class: 'popup-change-password popupSample' }"
          [showTitle]="true"
          title="Change Password"
          [dragEnabled]="false"
          [hideOnOutsideClick]="true"
          [(visible)]="__bPasswordChangePopUpVisible"
          [width]="750"
          [height]="'auto'">
  <div *dxTemplate="let data of 'content'">

    <div class="row" style="margin: auto; ">
      <div class="col-lg-12 popup-content">
        <table class="table">
          <tr style="">
            <td style="width:30%; border:none;">
              <div class="dx-field-label width-100">Domain Account :</div>
            </td>
            <td style="width:70%; border:none;">
              <div class="dx-field-value">{{__sDomainAccount}}</div>
            </td>
          </tr>
          <tr>
            <td style="width:30%; border:none;">
              <div class="dx-field-label width-100">Old Password :</div>
            </td>
            <td style="width:70%;border:none;">
              <input type="password" class="form-control" [(ngModel)]="__sOldPassword" />
            </td>
          </tr>
          <tr>
            <td style="width:30%; border:none;">
              <div class="dx-field-label width-100">New Password :</div>
            </td>
            <td style="width:70%; border:none;">
              <input type="password" class="form-control" [(ngModel)]="__sNewPassword" />
            </td>
          </tr>
          <tr>
            <td style="width:30%; border:none;">
              <div class="dx-field-label width-100">Confirm Password :</div>
            </td>
            <td style="width:70%; border:none;">
              <input type="password" class="form-control" [(ngModel)]="__sConfirmPassword" />
            </td>
          </tr>
        </table>
      </div>
    </div>

    <div class="row" style="margin-top:0.5rem;">
      <div class="col-lg-12">
        <table class="table" style="width:99%">
          <tr>
            <td style="width:40%;border:none;"></td>
            <td style="width:40%;border:none;"></td>
            <td style="width:20%;border:none;text-align:right;">
              <button id="btnApply" type="button" (click)="PopUpApply()" class="btn btn-info"><span>Apply</span></button>
              <!--<dx-button id="btnClose" text="Close" (onClick)="PopUpClose()" style="width:100px !important;"></dx-button>-->
            </td>
            <!--<td style="width:20%;border:none;"><dx-button id="btnPopUpConditionComplete" text="Complete" (onClick)="PopUpConditionComplete()" style="width:122px !important"></dx-button></td>-->
          </tr>
        </table>
      </div>
    </div>


  </div>
</dx-popup>

<dx-load-panel id="pnlLoad"
               shadingColor="rgba(0, 0, 0, 0.4)"
               [position]="{ at: 'center' }"
               [(visible)]="__bIsPopUpLoadingVisible"
               [showIndicator]="true"
               [showPane]="true"
               [shading]="true"
               [hideOnOutsideClick]="false"
               [height]="75"
               [width]="150"
               message="Please Wait...">
</dx-load-panel>

<div class="modal" id="TimeOutPopup" tabindex="-1" role="dialog"
     aria-labelledby="TimeOutPopupLabel" aria-hidden="true"
     style="z-index:99999999;display:none;">
  <div class="modal-dialog modal-dialog-centered" role="document" style="top:30%">
    <div class="modal-content">
      <div class="modal-header" style="background:#3892CF; color:white; " id="ModalHeader">
        <h4 class="modal-title" id="TimeOutPopupLabel" style="font-weight:900;
        font-family:Verdana,sans-serif,Arial">
          You Have Been Idle!
        </h4>
      </div>
      <div class="modal-body" style="display:block;font-weight:700;font-family:Verdana, sans-serif,Arial"
           id="dvStaySignedInModal">
        <div>Your session is about to expire. You will be automatically redirected in</div>
        <div><h2><span id="spIdleState"></span></h2></div>
        <div>To continue your session, select <b>Stay Signed In</b></div>
      </div>
      <div class="modal-body" style="display:none;font-weight:700;font-family:Verdana, sans-serif,Arial"
           id="dvReLoginModal">
        <div>Your session is <h2>EXPIRED!!</h2></div>
      </div>
      <div class="modal-footer" id="dvStaySignedIn" style="display:block;">
        <button type="button" (click)="StaySignedIn()" class="btn btn-info btn-filter"><span>Stay Signed In</span></button>
      </div>
      <div class="modal-footer" id="dvReLogin" style="display:none;">
        <button type="button" (click)="ReLogin()" class="btn btn-info btn-filter"><span>Re Login</span></button>
      </div>
    </div>
  </div>
</div>

<app-confirmation [__iPopupHeight]="'auto'"></app-confirmation>
